import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css";
import { connect } from "react-redux";
import { serverResponse } from "../util/fakeServer";
import LoadingPages from "./Loading.pages";
import { resetPasswordApi } from "../services/api.services";
import { language } from "../languageProvider/language/language";
import { defaultLanguage } from "../helper/utility";
import PasswordInput from "../components/common/PasswordInput";
import PasswordCriteria from "../components/common/PasswordCriteria";
import { isPasswordValid } from "../util/passwordValidation";

function ResetPassword(props) {
  const [errorReset, setErrorReset] = useState(null);
  const [feedMessage, setFeedMessage] = useState(false);
  const [form, setForm] = useState({
    password: "",
    confirm_password: "",
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onChange = ({ name, value }) => {
    setForm({ ...form, [name]: value });
    setErrorReset(null);
  };

  const handleOnPress = () => {
    setErrorReset(null);

    if (!isPasswordValid(form.password)) {
      setErrorReset(language[defaultLanguage].password_min_length);
      return;
    }

    if (form.password !== form.confirm_password) {
      setErrorReset(language[defaultLanguage].password_non_corrispondono);
      return;
    }

    setLoading(true);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const password_reset_token = urlParams.get("k");

    resetPasswordApi(password_reset_token, form.password)
      .then((res) => {
        if (res && res.status === 200) {
          setFeedMessage(language[defaultLanguage].password_cambiata_successo);
        } else {
          setErrorReset(res?.message || language[defaultLanguage].token_non_valido);
        }
      })
      .catch((err) => {
        setErrorReset(language[defaultLanguage].token_non_valido);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {}, []);

  if (
    !serverResponse.config.allow_login ||
    (props.authJWT.isAuthenticated && !props.authJWT.loadingProfile)
  ) {
    return navigate("/leaflet");
  }

  if (props.authJWT.loadingProfile) {
    return <LoadingPages />;
  }

  return (
    <div className="global-wrapper">
      <div className="main-container">
        <header>
          <div className={"header-headings sign-in"}>
            <span>{language[defaultLanguage].resetta_psw}</span>
          </div>
        </header>
        <ul className="options" style={{ listStyle: "none", padding: 0 }}>
          <li className="active">{language[defaultLanguage].rec_psw}</li>
        </ul>

        {!feedMessage ? (
          <form
            className="account-form"
            onSubmit={(evt) => {
              evt.preventDefault();
              handleOnPress();
            }}
          >
            <div
              className="account-form-fields"
              style={{ maxHeight: "none", overflow: "visible" }}
            >
              <PasswordInput
                value={form.password}
                id="password"
                name="password"
                placeholder={language[defaultLanguage].nuova_password}
                required
                onChange={(e) => {
                  onChange({ name: "password", value: e.target.value });
                }}
              />

              <PasswordCriteria password={form.password} />

              <PasswordInput
                value={form.confirm_password}
                id="confirm_password"
                name="confirm_password"
                placeholder={language[defaultLanguage].conferma_nuova_password}
                required
                onChange={(e) => {
                  onChange({
                    name: "confirm_password",
                    value: e.target.value,
                  });
                }}
              />
            </div>

            {!!errorReset && (
              <div
                style={{
                  color: "red",
                  textAlign: "center",
                  marginTop: "8px",
                }}
              >
                {errorReset}
              </div>
            )}

            <button
              className="btn-submit-form mt-3"
              type="submit"
              disabled={loading}
            >
              {loading ? (
                <div
                  className="spinner-border spinner-border-sm"
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
              ) : (
                language[defaultLanguage].resetta_psw
              )}
            </button>
          </form>
        ) : (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <p style={{ color: "#28a745", fontWeight: 600 }}>{feedMessage}</p>
            <button
              className="btn-submit-form mt-3"
              onClick={() => navigate("/login")}
            >
              {language[defaultLanguage].login}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  authJWT: state.authJWT,
});

export default connect(mapStateToProps)(ResetPassword);
